module.exports = __webpack_public_path__ + "media/audios/kid/lesson_3/audio4-09dad188364cd1e9c82899c2a734cb8e.m4a";